import type { Dimensions } from "schema/agent";
import type { AgentFiles } from "@/features/agent";
import bootstrapRaw from "./bootstrap.raw.js?raw";
import harnessRaw from "./harness.raw.js?raw";
import stylesRaw from "./styles.raw.css?raw";

/**
 * Combine all code blocks (init, helpers, render) into a single executable string.
 * Order: helpers first (they define functions), then init, then render.
 */
export function combineCode(files: AgentFiles): string {
  const parts: string[] = [];

  // Add helper functions first (they need to be defined before render can use them)
  if (files.helpers && Object.keys(files.helpers).length > 0) {
    for (const code of Object.values(files.helpers)) {
      parts.push(code);
    }
  }

  // Add init function
  parts.push(files.init);

  // Add render function
  parts.push(files.render);

  return parts.join("\n\n");
}

export function prepareBootstrapCode(assetUrlMapJson: string, dataJson = "{}"): string {
  return bootstrapRaw.replace("__ASSET_MAP__", assetUrlMapJson).replace("__DATA__", dataJson);
}

export function createBootstrapScript(assetUrlMapJson: string, dataJson = "{}"): string {
  return `<script>${prepareBootstrapCode(assetUrlMapJson, dataJson)}</script>`;
}

export function createHarnessScript(dimensions: Dimensions): string {
  return `<script>${harnessRaw
    .replace("__WIDTH__", String(dimensions.width))
    .replace("__HEIGHT__", String(dimensions.height))}</script>`;
}

export function createPreviewStyles(dimensions: Dimensions): string {
  return `<style>${stylesRaw.replace(
    "__ASPECT_RATIO__",
    `${dimensions.width} / ${dimensions.height}`,
  )}</style>`;
}
